import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getDigitalCard } from '../../utils/api';
import DigitalIDCard from './DigitalIDCard';
import './DigitalIDShare.css';

const DigitalIDShare = () => {
  const { id, name } = useParams();
  const [cardData, setCardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const loadCard = async () => {
      try {
        if (name) {
          console.log('📲 Fetching card by slug:', name);
          const cardOrArray = await getDigitalCard(name); 
          console.log('🔎 getDigitalCard returned:', cardOrArray);
          const slugify = (s = '') => s.toString().toLowerCase().trim()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '');
          const requested = String(name).toLowerCase();

          let card = null;
          if (Array.isArray(cardOrArray)) {
            console.log('⚠️ API returned array, attempting robust matching for slug:', requested);
            card = cardOrArray.find(c => (c.url_slug || '').toLowerCase() === requested);
            if (!card) card = cardOrArray.find(c => slugify(c.name) === requested);
            if (!card && !isNaN(Number(requested))) card = cardOrArray.find(c => String(c.id) === requested);
            if (!card) card = cardOrArray.find(c => (c.name || '').toLowerCase().includes(requested.replace(/-/g, ' ')));
            console.log('🔎 Matching result:', card);
          } else {
            card = cardOrArray;
          }

          if (card) {
            setCardData(card);
            setLoading(false);
            return;
          }
        }
        
        console.error('❌ No valid card slug in URL');
        setNotFound(true);
      } catch (error) {
        console.error('❌ Error loading card:', error);
        setNotFound(true);
      } finally {
        setLoading(false);
      }
    };

    loadCard();
  }, [id, name]);
  
  useEffect(() => {
    if (cardData) {
      const pageTitle = cardData.position 
        ? `${cardData.name} - ${cardData.position}` 
        : cardData.name;
      document.title = pageTitle;
    }
    
    return () => {
      document.title = 'Digital ID Card';
    };
  }, [cardData]);

  if (loading) {
    return (
      <div className="share-loading">
        <div className="loading-spinner">
          <img 
            src="/assets/jethro.svg" 
            alt="Loading..." 
            className="loading-logo"
          />
        </div>
      </div>
    );
  }

  if (notFound || !cardData) {
    return (
      <div className="share-not-found">
        <h2>❌ Digital ID Card Not Found</h2>
        <p>This card may have been deleted or the link is invalid.</p>
        <p style={{ fontSize: '14px', color: '#666', marginTop: '20px' }}>
          Slug: {name || 'N/A'}
        </p>
        <button 
          onClick={() => window.location.href = '/'}
          style={{
            marginTop: '20px',
            padding: '10px 20px',
            background: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer'
          }}
        >
          Go to Homepage
        </button>
      </div>
    );
  }

  return (
    <div className="share-container">
      {/* Pure Digital ID Card - No other elements */}
      <DigitalIDCard 
        cardData={cardData} 
        isPreview={false}
      />
    </div>
  );
};

export default DigitalIDShare;
